import { createApiEffect } from '@/features/api/common/create-api-effect'
import { FAQType } from '@/features/api/content/types'

export const getQuestionByIdFx = createApiEffect<string, FAQType>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/content-app/faq/${id}/`,
  }),
})
